import pakFlag from './static/images/pakistan.svg';
import saudiFlag from './static/images/saudi-arabia.svg';
import tagalogFlag from './static/images/tagalog.svg';
import indianFlag from './static/images/india.svg';
import englishFlag from './static/images/english.svg';
import chinaFlag from './static/images/china.svg';
import banglaFlag from './static/images/bangladesh.svg';

export const HTTP_PROTOCOL = "https://";
export const API_KEY = process.env.REACT_APP_OT;
export const API_ROOT_URL = `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_API_URL}`;
export const logger = process.env.REACT_APP_LOGGER_ENABLE;
export const PatientDesiredRole = 1;
export const CounsellorDesiredRole = 0;
export const paypalClientId = process.env.REACT_APP_PAYPAL_CLIENT_ID;
export const enableGA = process.env.REACT_APP_GA_ENABLE;
export const Counsellor_Portal_URL = process.env.REACT_APP_COUNCELLOR_PORTAL;
export const Sub_Domain = process.env.REACT_APP_SUBDOMAIN;
export const enable_Bugsnag = process.env.REACT_APP_ENABLE_BUGSNAG;
export const bugsnag_APIKEY = process.env.REACT_APP_BUGSNAG_APIKEY;
export const contactUsEmail = process.env.REACT_APP_CONTACT_US_EMAIL;
export const b2cURL = process.env.REACT_APP_B2C_PORTAL_URL;
export const foreeApiKey = process.env.REACT_APP_FOREE_API_KEY;
export const foreeCheckoutStatus = process.env.REACT_APP_FOREE_CHECKOUT;
export const gtmId = process.env.REACT_APP_GTM_ID;



// Setting whitelabel for counsellor
export const whitelabelObj = [
  {
    id: "2465a1f1-36eb-48a7-8b5b-232cf3dfd3cb",
    name: "Counsellor",
    domain: "iba.edu.pk",
    sys_domain: "counsellor.saayahealth.com",
    sub_domain: "councellor",
    logo_url:
      "https://dev-api.saayahealther.com/media/logo/Saaya_Logo_Final-1_omIYDeI.svg",
    email_domain: "['all']",
    app_version: "2.0.0",
    date_created: "2020-03-26T07:10:13.891414Z",
    date_modified: "2020-04-13T11:58:49.915539Z",
    consumer_role: "client",
    payment_required: false,
    producer_role: "counsellor",
    slot_threshold: "24",
  },
];

export const languagesArray =[
  {
    value:'english',
    key: 'English',
    image: englishFlag
}, {
    key: 'اردو',
    value:'urdu',
    image: pakFlag
}, {
    key: 'عربى',
    value:'arabic',
    image: saudiFlag
}, {
    key: '中国人',
    value:'mandarin',
    image: chinaFlag
}, {
    key: 'বাংলা',
    value:'bangla',
    image: banglaFlag 
}, {
    key: 'हिन्दी',
    value:'hindi',
    image: indianFlag
},
{
    key: 'Tagalog',
    value:'tagalog',
    image: tagalogFlag
},
  
]



// WEBPACK FOOTER //
// ./src/config.js